/**
 * History actions
 */
import { dispatch } from 'store';

import { HISTORY_SET } from '../action-types/history.action-types';

// eslint-disable-next-line import/prefer-default-export
export const setHistory = (history: Array<string>) => dispatch({ type: HISTORY_SET, history });
